import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path d="M35.408,29.464H4.591V10.536h30.817V29.464z M6.591,27.464h26.817V12.536H6.591V27.464z" />
    <g>
      <path
        d="M13.167,25.287c-2.916,0-5.287-2.372-5.287-5.287c0-2.916,2.372-5.287,5.287-5.287s5.287,2.372,5.287,5.287
		C18.455,22.915,16.083,25.287,13.167,25.287z M13.167,16.713c-1.813,0-3.287,1.475-3.287,3.287s1.475,3.287,3.287,3.287
		s3.287-1.475,3.287-3.287S14.98,16.713,13.167,16.713z"
      />
      <path
        d="M26.832,25.287c-2.915,0-5.287-2.372-5.287-5.287c0-2.916,2.372-5.287,5.287-5.287s5.287,2.372,5.287,5.287
		C32.119,22.915,29.747,25.287,26.832,25.287z M26.832,16.713c-1.813,0-3.287,1.475-3.287,3.287s1.475,3.287,3.287,3.287
		s3.287-1.475,3.287-3.287S28.645,16.713,26.832,16.713z"
      />
    </g>
    <rect x="13.167" y="14.713" width="13.665" height="2" />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/RecordTape.jsx